import { makeStyles } from '@material-ui/core/styles';

import { blue, neutral } from 'shared/styles/colors';

export default makeStyles({
  item: {
    padding: '1rem 1.5rem',
    gap: '1rem',
    border: `1px solid ${neutral['20']}`,
    '&.Mui-selected': {
      backgroundColor: neutral['10'],
      '&:hover': {
        backgroundColor: neutral['10'],
      },
    },
  },

  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    '@media screen and (width >= 580px)': {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  textMultiline: {
    margin: 0,
  },
  textPrimary: {
    marginBottom: '0.25rem',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1rem',
    color: neutral[100],
    textWrap: 'pretty',
    '@media screen and (width >= 768px)': {
      fontSize: '1rem',
      lineHeight: '1.25rem',
    },
  },
  textSecondary: {
    maxWidth: '40rem',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1rem',
    color: neutral[70],
    '& p[aria-label="product-description"]': {
      display: '-webkit-box',
      textWrap: 'pretty',
      overflow: 'hidden',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
    },
    '& p[aria-label="show-customs-label"]': {
      marginTop: '0.25rem',
      fontSize: '0.75rem',
      lineHeight: '1rem',
      color: blue[50],
      cursor: 'pointer',
    },
  },
  onOff: {
    width: '100%',
    maxWidth: 'max-content',
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
  },
});
